export default "__VITE_ASSET__DQbXCygb__"